import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/FeatureStackConfiguration.ts
var n = class extends t {
	async put(t, n) {
		let r = `/commerceservice/restricted/organizations/${e.orgPlaceholder}/commerce/tracking-ids/${t}/feature-stack/configuration`;
		await this.api.put(r, n);
	}
};
export { n as FeatureStackConfiguration };

//# sourceMappingURL=FeatureStackConfiguration.js.map